import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../lib/domain';
import { Spin, Row, Col, message, Pagination, Empty, Input, Table, Button } from 'antd';
import ErrorWrapper from '../../lib/error_wrapper';
import { BasicHeader } from '../../components/basic_header';
import SourceMapItem from '../../components/source_map_item';
import { PopUpForm } from '../../lib/ui/popupform';
import { showErrorInNotification, NetworkDelaySearch, formatMoney } from '../../lib/util';
import FilterFixedInput from '../../components/filter_fixed_input';
import NetworkSelect from '../../lib/ui/network_select';
import { Link } from 'react-router-dom';
import DayDifferennceTag from '../../components/day_difference_tag';
import DirectSourceReport from './direct_source_report';

const queryString = require('query-string');

class GroupDetail extends Component {
  constructor(props) {
    super(props)

    this.state = {
      group_obj: {},
      loading: true,
      filter_query: {},
      selected_source_id: null,
      selected_source_label: '',
      form_data: {}
    }
    this.group_id = props.match.params.group_id;

    this.detail_group = RESTExecutor.detail().config({
      label: 'detail'
    }).callbacks((success) => {
      this.setState({ loading: false, group_obj: success.result })
      this.list_sources.config({
        params: {
          ...this.state.filter_query,
          group_id: this.group_id
        }
      }).execute();
    }, (error) => {
      this.setState({ loading: false })
    }).connect(props.domains.usergroups);

    this.list_sources = RESTExecutor.list().config({
      label: 'groupsources'
    }).connect(props.domains.usergroups);

    this.add_source_label = RESTExecutor.post().config({
      url: '/my-group-source-labels'
    }).callbacks((success) => {
      message.success("Source Label Added");
      this.setState({
        selected_source_id: null,
        selected_source_label: ''
      })
      this.list_sources.execute();
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.usergroups);

    this.remove_source_label = RESTExecutor.delete().config({
      url: '/my-group-source-labels'
    }).callbacks((success) => {
      message.success("Source Label Removed");
      this.setState({
        selected_source_id: null,
        selected_source_label: ''
      })
      this.list_sources.execute();
    }, (error) => {
      showErrorInNotification(error);
    }).connect(props.domains.usergroups);

    this.delay_search = new NetworkDelaySearch();


  }

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  render() {
    const { filter_query, group_obj, loading, selected_source_id, selected_source_label, form_data } = this.state;
    let list_sources_resp = this.list_sources.response();
    let add_source_label_resp = this.add_source_label.response();
    let rowsData = (list_sources_resp.result && list_sources_resp.result.rows) || [];
    let rowsMeta = list_sources_resp.meta || {};

    let total_datatype = (rowsData.length / rowsMeta.data_count);

    let getRowSpan = (index) => {
      return 1;
      let _rowSpan = 0;
      let previous_data = rowsData[index - 1] || {};
      let next_data = rowsData[index + 1] || {};
      let row = rowsData[index] || {};


      if (previous_data.source_id != row.source_id) {
        _rowSpan = total_datatype
        // obj.children = value
      }
      return _rowSpan
      // if (previous_data.source_id != row.source_id && next_data.source_id == row.source_id) {
      // obj.children = value;
      // obj.props.className = 'cell-no-bottom-border'
      // }

      // if (next_data.source_id == row.source_id && previous_data.source_id == row.source_id) {
      // obj.props.className = 'cell-no-bottom-border'
      // }
    }

    if (loading) {
      return <center><Spin /></center>
    }
    let detail_group_resp = this.detail_group.response();
    let resp_card = { xs: 24, sm: 24, md: 12, lg: 8, xl: 8 }

    return (
      <ErrorWrapper error={detail_group_resp}
        onReload={() => {
          this.setState({ loading: true })
          this.detail_group.forId(this.group_id).execute()
        }}
      >
        <BasicHeader
          title={group_obj.name}
          titleType="Group"
          subtitle="Sources"

        // right={[
        //         <TransparentButton
        //             label="Add New"
        //             className='cta-primary'
        //             hint="Add New Datatype"
        //             onClick={() => {
        //                 this.setState({
        //                     edit_id: null,
        //                     form_data: {},
        //                     form_visibility: true
        //                 })
        //             }}

        //         />,
        //         <Link to={`/settings/groups/${this.group_id}/source`} >
        //         <TransparentButton
        //             label="Source"
        //             icon={<WifiTetheringOutlined />}
        //             hint="View Sources"
        //         />
        //     </Link>,
        //     <Link to={`/settings/groups/${this.group_id}/reconcilers`} >
        //         <TransparentButton
        //             label="Processor"
        //             icon={<FlipOutlined />}
        //             hint="View Reconcilers"
        //         />
        //     </Link>,
        //         <TransparentButton
        //             label="Export"
        //             hint="Export Selected Datatype"
        //             disabled={selected_ids.length == 0}
        //             onClick={() => {
        //                 this.export_data.execute({
        //                     data_types: this.state.all_selected ? true : selected_ids
        //                 });
        //             }}

        //         />
        //     ]}

        />

        <div className='filter-card'>

          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'nowrap',
            paddingTop: 4, paddingBottom: 12,
            alignItems: 'center'
          }}>
            <Input.Search
              placeholder="Search For"
              style={{
              }}
              autoFocus
              value={filter_query.query}
              onChange={(e) => {
                this.stateUpdater({
                  stateKey: 'filter_query', valueKey: 'query', value: e.target.value, callback: () => {
                    this.delay_search.onSearch(() => {
                      this.props.history.push({
                        // pathname:"users",
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                    })

                  }
                })
              }} />
            <FilterFixedInput
              // label="Label" 
              containerStyle={{
                margin: 0,
                marginLeft: 16
              }}>
              <NetworkSelect
                value={filter_query.label_id}
                // style={{margin:4}}
                item={{
                  name: "Label", display_key: 'label',
                  className: filter_query.label_id != null ? 'filter-option-selected' : ''
                }}
                url={`/my-group-source-labels?group_id=${this.group_id}`}
                onChange={(received_value) => {
                  this.stateUpdater({
                    stateKey: 'filter_query',
                    valueKey: 'label_id',
                    value: received_value,
                    callback: () => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, page: 1 })
                      })
                      // this.list_logs.config({
                      //   params: {
                      //     ...this.getParams()
                      //   }
                      // }).execute()
                    }
                  })
                  // this._change(item.index, received_value, d_key)
                }}
              />
            </FilterFixedInput>
          </div>

          {/* <div style={{
            display: 'flex',
            flexDirection: 'row',
            // justifyContent: 'space-between',
            flexWrap: 'wrap',
            paddingTop: 4, paddingBottom: 4
          }}>
            
          </div> */}
        </div>


        <ErrorWrapper
          error={list_sources_resp}
          onReload={() => {
            this.list_sources.execute()
          }}
        >
          <PopUpForm
            title={`Assign Label For ${selected_source_label}`}
            show_title_only
            forCreate={true}
            initialData={form_data}
            fields={[
              { index: 'label_id', display_key: 'label', type: 'networkselect', name: "Label", url: `/my-group-source-labels?group_id=${this.group_id}&source_id=${selected_source_id}` },
            ]}
            open={selected_source_id != null}
            networkState={add_source_label_resp}
            onClose={() => this.setState({ selected_source_id: null, selected_source_label: '' })}
            onSubmit={(data) => {
              console.log("DATA", data);
              this.add_source_label.execute({
                ...data,
                group_source_id: selected_source_id
              })
              // this.handlePostPatch(data);
            }} />
          <div
            // className='default-card' 
            style={{
              padding: 8,
              paddingTop: 0
            }}>
            <Table
              loading={list_sources_resp.fetching}
              dataSource={rowsData}
              className='main-table  noHover customCardTable1 sticky-table-header'
              // bordered={true}
              size='small'
              columns={[
                {
                  title: "Source Name",
                  dataIndex: 'source_name',
                  // rowSpan:getRowSpan(),
                  render: (value, row, index) => {
                    const obj = {
                      children: <Link to={{
                        pathname: `/processors/groups/${this.group_id}/sources/${row.source_id}`
                      }}>{value}</Link>,
                      props: {
                        rowSpan: getRowSpan(index)
                      },
                    };
                    // let previous_data = rowsData[index - 1] || {};
                    // let next_data = rowsData[index + 1] || {};

                    // if (previous_data.source_id != row.source_id) {
                    //   obj.children = <Link to={{
                    //     pathname: `/recon/groups/${this.group_id}/sources/${row.source_id}`
                    //   }}>{value}</Link>;
                    //   // obj.props.rowSpan=2
                    // }
                    // else {
                    //   // obj.props.rowSpan = 0
                    //   // obj.props.colSpan=1
                    // }

                    // if (previous_data.source_id != row.source_id && next_data.source_id == row.source_id) {
                    //   obj.children = <Link to={{
                    //     pathname: `/recon/groups/${this.group_id}/sources/${row.source_id}`
                    //   }}>{value}</Link>;
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }

                    // if (next_data.source_id == row.source_id && previous_data.source_id == row.source_id) {
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }

                    return obj;
                  }

                },
                {
                  // title: "Processor",
                  // children: [
                  // {
                  title: "Last Processed",
                  dataIndex: 'last_reconciled_at',
                  key: 'last_reconciled_at',
                  className: 'center-align',
                  render: (_value, row, index) => {
                    let value = _value || "-";
                    const obj = {
                      children: <div style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center'
                      }}> <DayDifferennceTag date={value} /> </div>,
                      props: {
                        rowSpan: getRowSpan(index)
                      },
                    };
                    // let previous_data = rowsData[index - 1] || {};
                    // let next_data = rowsData[index + 1] || {};

                    // if (previous_data.source_id != row.source_id) {
                    //   obj.children = value
                    // }
                    // if (previous_data.source_id != row.source_id && next_data.source_id == row.source_id) {
                    //   obj.children = value;
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }

                    // if (next_data.source_id == row.source_id && previous_data.source_id == row.source_id) {
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }
                    return obj;
                  }
                },
                {
                  title: "Pending",
                  dataIndex: 'pending',
                  className: 'right-align',
                  render: (_value, row, index) => {
                    let value = <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}>
                      <span className='right-align'>{_value != null ? formatMoney(_value, 0) : "-"}</span>
                    </div>
                    const obj = {
                      children: value,
                      props: {
                        rowSpan: getRowSpan(index)
                      },
                    };
                    // let previous_data = rowsData[index - 1] || {};
                    // let next_data = rowsData[index + 1] || {};

                    // if (previous_data.source_id != row.source_id) {
                    //   obj.children = value
                    // }
                    // if (previous_data.source_id != row.source_id && next_data.source_id == row.source_id) {
                    //   obj.children = value;
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }

                    // if (next_data.source_id == row.source_id && previous_data.source_id == row.source_id) {
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }
                    return obj;
                  }
                },
                {
                  title: "Unprocessed",
                  dataIndex: 'unreconciled',
                  className: 'right-align padding-right',
                  render: (_value, row, index) => {
                    let value = <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}>
                      <span className='right-align'>{_value != null ? formatMoney(_value, 0) : "-"}</span>
                    </div>
                    const obj = {
                      children: value,
                      props: {
                        rowSpan: getRowSpan(index)
                      },
                    };
                    // let previous_data = rowsData[index - 1] || {};
                    // let next_data = rowsData[index + 1] || {};

                    // if (previous_data.source_id != row.source_id) {
                    //   obj.children = value
                    // }
                    // if (previous_data.source_id != row.source_id && next_data.source_id == row.source_id) {
                    //   obj.children = value;
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }

                    // if (next_data.source_id == row.source_id && previous_data.source_id == row.source_id) {
                    //   obj.props.className = 'cell-no-bottom-border'
                    // }
                    return obj;
                  }
                  // }
                  // ]
                },
                {
                  dataIndex: "source_name",
                  render: (value, row, index) => {
                    const obj = {
                      children: <DirectSourceReport source_name={value} />,
                      props: {
                        rowSpan: getRowSpan(index)
                      }
                    }
                    return obj
                  }
                },
                {
                  title: "Datatype",
                  dataIndex: 'data_types',
                  className: 'left-border padding-left',
                  render: (datatypes = [], record, index) => {

                    return <div style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {datatypes.map((item, index) => {
                        let value = item.name
                        return <div style={{
                          marginTop: index == 0 ? 0 : 8
                        }}>{value}</div>
                      })}
                    </div>
                  }
                  // align:'center'
                },
                {
                  title: "Label",
                  dataIndex: 'data_types',
                  className: '',
                  render: (datatypes = [], record, index) => {

                    return <div style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {datatypes.map((item, index) => {
                        let value = item.label
                        return <div style={{
                          marginTop: index == 0 ? 0 : 8
                        }}>{value}</div>
                      })}
                    </div>
                  }
                  // align:'center'
                },
                {
                  // title: "Transfer",
                  // children: [
                  // {
                  title: "Last Transfered",
                  dataIndex: 'data_types',
                  key: 'last_transferred',
                  className: 'center-align',
                  render: (datatypes = [], record, index) => {

                    return <div style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {datatypes.map((item, index) => {
                        let value = item.last_transferred;

                        return <div style={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'center',
                          alignItems: 'center',
                          marginTop: index == 0 ? 0 : 8
                        }}> <DayDifferennceTag date={value} /> </div>
                      })}
                    </div>
                  }
                },
                {
                  title: "Max Txn Date",
                  dataIndex: 'data_types',
                  key: 'max_txn_date',
                  render: (datatypes = [], record, index) => {

                    return <div style={{
                      display: 'flex',
                      flexDirection: 'column'
                    }}>
                      {datatypes.map((item, index) => {
                        let value = item.max_txn_date;
                        return <div style={{
                          marginTop: index == 0 ? 0 : 8
                        }}>{value || "-"}</div>
                      })}

                    </div>
                  }
                  // },
                  // ]
                },
                {
                  title: "Packets in queue",
                  dataIndex: 'data_types',
                  align: 'right',
                  width: 100,
                  render: (datatypes = [], record) => {
                    return <div style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'flex-end'
                    }}>
                      {datatypes.map((item, index) => {
                        let value = item.queue_packets;
                        return value > 0 ? <Link to={{
                          pathname: `/activity/data-type/${item.id}/packets/forsource`,
                          search: queryString.stringify({
                            transferred: 'false',
                            source_id: item.label
                          })
                        }}>  <span style={{
                          marginTop: index == 0 ? 0 : 8
                        }} className='right-align'>{formatMoney(value, 0)}</span></Link> :
                          <span style={{
                            marginTop: index == 0 ? 0 : 8
                          }} className='right-align'>{value != null ? formatMoney(value, 0) : "-"}</span>
                      })}

                    </div>
                  },
                  childrens: [
                    {
                      title: "Packets",
                      dataIndex: 'packets_count',
                      render: (value, record) => <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end'
                      }}>
                        {value > 0 ? <Link to={{
                          pathname: `/activity/data-type/${record.data_type_id}/packets/forsource`,
                          search: queryString.stringify({
                            transferred: 'false',
                            source_id: record.label
                          })
                        }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :
                          <span className='right-align'>{value != null ? formatMoney(value, 0) : "-"}</span>
                        }
                      </div>

                    },
                    // {
                    //   title:"Txns",
                    //   dataIndex:'txns_count',
                    //   className: 'right-align',
                    //   render: (value, record) => <div style={{
                    //       display: 'flex',
                    //       flexDirection: 'column',
                    //       alignItems: 'flex-end'
                    //   }}>
                    //       {value > 0 ? <Link to={{
                    //           pathname: `/activity/data-type/${record.data_type_id}/nottransferredtransactions`,
                    //           search: queryString.stringify({
                    //             source_id:record.label
                    //           })
                    //       }}>  <span className='right-align'>{formatMoney(value, 0)}</span></Link> :
                    //       <span className='right-align'>{value != null ? formatMoney(value, 0) : "-"}</span>
                    //        }
                    //   </div>
                    // },
                    // {
                    //   title:"Range",
                    //   width:150,
                    //   dataIndex:'range',
                    //   className: 'right-align',
                    //   render: (_value, row, index) => {
                    //     let value=_value||"-"
                    //     return value
                    //   }
                    // // render:(value,row)=><div>{row.min_txn_date} - {row.max_txn_date}</div>
                    // },
                  ]
                },
              ]}

              pagination={{
                size: 'small',
                onChange: (current, size = 0) => {
                  this.props.history.push({
                    search: queryString.stringify({ ...this.state.filter_query, per_page: size / (rowsData.length / rowsMeta.data_count), page: current })
                  })
                },
                defaultCurrent: 1,
                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                pageSize: rowsMeta && (rowsMeta.requested_count * (rowsData.length / rowsMeta.data_count)),
                total: (rowsMeta && (rowsMeta.total_count * (rowsData.length / rowsMeta.data_count))),
                // showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`

                showTotal: (total, range) => `${((filter_query.page - 1) * filter_query.per_page) + 1}-${(filter_query.page - 1) * filter_query.per_page + rowsMeta.data_count} of ${rowsMeta.total_count} items`,

              }}
            />
            {console.log("filter query", filter_query)}
          </div>
          {/* <Spin spinning={list_sources_resp.fetching}>
            <Row>
              {rowsData.map((item) => {
                return <Col {...resp_card}>
                  <SourceMapItem
                    group_id={this.group_id}
                    onAssignLabelClicked={(source_id, data) => {
                      this.setState({
                        selected_source_id: source_id,
                        selected_source_label: data.name
                      })
                    }}
                    onRemoveLabel={(label_id) => {
                      this.remove_source_label.config({
                        url: `/my-group-source-labels/${label_id}`
                      }).execute()
                    }}
                    key={item.id}
                    data={item}
                  />
                </Col>
              })}
              {((!list_sources_resp.fetching) && rowsData.length == 0) ? <Col span={24}>
                <Empty />
              </Col> : null}
              <Col span={24} style={{
                paddingBottom: 16, paddingTop: 16
              }}>
                {rowsData.length > 0 ? <Row justify='end'>
                  <Pagination
                    size='small'
                    onChange={(current, size) => {
                      this.props.history.push({
                        search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                      })
                    }}
                    defaultCurrent={1}
                    current={rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0])}
                    pageSize={(rowsMeta && rowsMeta.data_count)}
                    total={(rowsMeta && rowsMeta.total_count)}
                  />
                </Row> : null}

              </Col>
            </Row>
          </Spin> */}
        </ErrorWrapper>



      </ErrorWrapper >
    );
  }


  componentDidMount() {


    let new_filter_query = {};
    if (this.props.location && this.props.location.search) {
      const parsed = queryString.parse(this.props.location.search);
      new_filter_query = parsed;
    }
    this.setState({
      filter_query: {
        per_page: 100,
        page: 1,
        ...new_filter_query,
        group_id: this.group_id
      }
    }, () => {
      this.detail_group.forId(this.group_id).execute()
    })
  }
  componentWillReceiveProps(nextProps) {
    var oldgroup_id = this.props.match.params.group_id;
    var newgroup_id = nextProps.match.params.group_id;


    if (oldgroup_id !== newgroup_id || (
      this.props.location && (this.props.location.search !== nextProps.location.search)
    )) {
      this.group_id = newgroup_id;
      const parsed = queryString.parse(nextProps.location.search);
      this.setState({
        filter_query: {
          per_page: 100,
          page: 1,
          ...parsed,
          group_id: this.group_id
        },
      }, () => {
        if (oldgroup_id !== newgroup_id) {
          this.setState({
            loading: true
          }, () => {
            this.detail_group.forId(this.group_id).execute()
          })
        } else {
          this.list_sources.config({
            params: {
              ...this.state.filter_query
            }
          }).execute()
        }
      })

    }
  }

}

export default withDomains(GroupDetail, "usergroups");
